<template>
  <div class="app-content">
    <project-header
      default-active="Setting"
      v-if="projectInfo.template"
      :project-info="projectInfo"
    ></project-header>
    <side-menu :project="projectInfo" class="side-menu"></side-menu>
    <section v-loading="loading" class="main-content">
      <!-- <transition name="fade-transform" mode="out-in"> -->
      <router-view
        ref="child"
        :project-info="projectInfo"
        @refresh-project="refreshProject"
      ></router-view>
      <!-- </transition> -->
    </section>
  </div>
</template>

<script>
import SideMenu from "./SideMenu"
import ResizeHandler from "./mixin/ResizeHandler"
import ProjectHeader from "@/views/Front/Project/Layout/ProjectHeader"
import { getProject } from "@/api/project/project"
import { getProjectPri } from "@/utils/checkPermission"
import ProvideCurCompanyUsers from "@/mixins/provideCurCompanyUsers"
import ProvideRootDepartment from "@/mixins/provideRootDepartment"

export default {
  name: "ProjectLayout",
  components: {
    SideMenu,
    ProjectHeader
  },
  mixins: [ResizeHandler, ProvideCurCompanyUsers, ProvideRootDepartment],
  data() {
    return {
      loading: false,
      projectId: this.$route.params?.projectId,
      projectInfo: {
        template: Boolean(this.$route.query.template)
      }
    }
  },
  created() {
    this.loading = true
    Promise.all([this.getProjectPri(), this.getProject()]).finally(() => (this.loading = false))
  },
  methods: {
    getProjectPri() {
      return getProjectPri(this.projectId)
        .then(userPermission => {
          if (!userPermission.isAdmin) {
            return Promise.reject("权限不足")
          }
        })
        .catch(res => {
          this.$router.push({ name: "home" })
          this.$message.error(res)
        })
    },
    getProject() {
      return getProject(this.projectId).then(project => {
        this.projectInfo = project
      })
    },
    refreshProject() {
      this.loading = true
      this.getProject().then(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-content {
  width: 100%;
  height: 100%;
  z-index: 10;
  .side-menu {
    position: absolute;
    left: 0;
    top: 0;
    width: 240px;
    height: 100%;
    z-index: 2;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(33, 43, 54, 0.1);
    color: #2a304d;
  }
  .main-content {
    background: #ffffff;
    position: relative;
    height: 100%;
    margin-left: 240px;
    overflow: hidden;
    z-index: 1;
    ::v-deep {
      .top-wrap {
        display: flex;
        align-items: center;
        padding: 16px 16px 8px;
        .main-title {
          font-size: 18px;
          line-height: 18px;
          line-height: 32px;
          font-weight: bold;
          margin-right: auto;
        }
        .right {
          display: flex;
        }
      }
      .main-wrap {
        position: absolute;
        top: 56px;
        left: 0;
        width: 100%;
        height: calc(100% - 56px - 48px);
        .base-table {
          height: 100%;
        }
      }
    }
  }
}
</style>
